export default String.raw`
{% assign lookbook_data = config.Lookbook.Current -%}
<ul class="breadcrumbs breadcrumbs-js">
	{% for breadcrumb in page.Breadcrumbs -%}
		{% assign first = page.Breadcrumbs | First %}
		{% assign last = page.Breadcrumbs | Last %}
		{% if breadcrumb.Id == first.Id -%}
			<li><a href="{{ page.BaseHref }}{{ breadcrumb.Url | Replace: '^\./', '' }}" aria-label="{{ breadcrumb.Name }}">{{ breadcrumb.Name }}</a></li>
		{% elseif breadcrumb.Id == last.Id and page.PageId != 26 -%}
			<li>
				<span>
					{% if breadcrumb.Heading -%}{{ breadcrumb.Heading }}{% else -%} {% if page.QueryString contains 'wishlists' -%} {{ translations.WishLists }} {% elseif page.QueryString contains 'wishlist' -%} {{translations.WishList}} {% else -%} {{ breadcrumb.Name }} {% endif -%} {% endif -%}{% if headingTag %} - {{ headingTag }}{% endif %}{% if postList.TotalItems %} ({{ postList.TotalItems }}){% endif %}
				</span>
			</li>
		{% elseif page.PageId != 26 -%}
			<li>{% if breadcrumb.Url != null and breadcrumb.Url != '' %}{% capture aHref -%}{% include 'partials/common/user-link.html', userLink: breadcrumb.Url -%}{% endcapture -%}{% assign aHrefAttr = 'href="' | Append: aHref | Append: '"' %}{{ breadcrumb | A | Replace: 'href="[^"]*"', aHrefAttr }}{% else %}{{ breadcrumb | A }}{% endif %}</li>
		{% endif -%}
	{% endfor -%}
	{% if lookbook_data != null and page.PageId == 26 -%}
		{% assign link = config.Pages[25].Url -%}
		<li><a href="{{ page.BaseHref }}{{ link }}" aria-label="{{ page.MetaTitle }}">{{ page.MetaTitle }}</a></li>
		<li>
			<span>
				{{ lookbook_data.Text }}
			</span>
		</li>
	{% elseif lookbook_data == null and page.PageId == 26 -%}
		<li>
			<span>
				{{ page.MetaTitle }}
			</span>
		</li>
	{% endif -%}
</ul>
{% include 'partials/rich-snippets/breadcrumbs.html' -%}
`